/**
 * Social profile links with simple, original line glyphs (the old theme used a
 * licensed icon font and a sprite image). Shared by the header's mobile panel,
 * the footer and the blog sidebar. Styled by chrome.css .ve-social.
 *
 *   <SocialLinks />   <SocialLinks className="ve-footer-social" />
 */
const GLYPHS: Record<string, JSX.Element> = {
  google: <path d="M20 12.2c0-.6 0-1.1-.1-1.6H12v3.2h4.5a4.6 4.6 0 0 1-4.5 3.4 5.2 5.2 0 1 1 3.4-9.1l2.2-2.2A8.3 8.3 0 1 0 20 12.2z" fill="currentColor" />,
  facebook: <path d="M13.5 21v-7.5h2.6l.4-3h-3V8.6c0-.9.3-1.5 1.5-1.5h1.6V4.4c-.3 0-1.2-.1-2.3-.1-2.3 0-3.8 1.4-3.8 3.9v2.3H8v3h2.5V21z" fill="currentColor" />,
  instagram: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9">
      <rect x="4" y="4" width="16" height="16" rx="4.5" />
      <circle cx="12" cy="12" r="3.6" />
      <circle cx="16.8" cy="7.2" r="0.6" fill="currentColor" />
    </g>
  ),
  youtube: (
    <g>
      <rect x="2.5" y="5.5" width="19" height="13" rx="4" fill="none" stroke="currentColor" strokeWidth="1.9" />
      <path d="m10 9 5 3-5 3z" fill="currentColor" />
    </g>
  ),
  x: <path d="M5 4h3.6l4.1 5.6L17.5 4h1.9l-5.8 6.8L20 20h-3.6l-4.4-6-5.2 6H4.9l6.2-7.1z" fill="currentColor" />,
  yelp: <path d="M12 3.5 14.4 9h5.8l-4.7 3.5 1.8 5.7L12 14.7l-5.3 3.5 1.8-5.7L3.8 9h5.8z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />,
  tiktok: <path d="M13.5 4v10.2a2.8 2.8 0 1 1-2.8-2.8M13.5 4c.4 2.4 2 4 4.5 4.2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />,
};

const SOCIAL_PROFILES: Array<{ key: keyof typeof GLYPHS; label: string; href: string }> = [
  { key: 'google', label: 'Google reviews', href: 'https://goo.gl/maps/gbypiRdXmWq4YJ4g8' },
  { key: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/Vaneverychiro/' },
  { key: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/vaneveryfamilychiropractic/' },
  { key: 'youtube', label: 'YouTube', href: 'https://www.youtube.com/channel/UCdmD-wY1dX1W1YTW0Y0AtgA' },
  { key: 'x', label: 'X', href: 'https://x.com/VEchiropractic' },
  { key: 'yelp', label: 'Yelp', href: 'https://www.yelp.com/biz/van-every-family-chiropractic-center-royal-oak-2' },
  { key: 'tiktok', label: 'TikTok', href: 'https://www.tiktok.com/@vaneverychiropractic' },
];

export default function SocialLinks({ className = '' }: { className?: string }) {
  return (
    <span className={`ve-social-row ${className}`.trim()}>
      {SOCIAL_PROFILES.map((s) => (
        <a key={s.key} className="ve-social" href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`Van Every on ${s.label}`}>
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
            {GLYPHS[s.key]}
          </svg>
        </a>
      ))}
    </span>
  );
}
